// <s-sticky-atc> — reveals the mobile add-to-cart bar only while the main add-to-cart button is out of view.
class SStickyAtc extends HTMLElement {
  #observer;

  connectedCallback() {
    const target = document.querySelector('[data-main-atc]');
    if (!target) return;
    this.#setVisible(false);
    this.#observer = new IntersectionObserver(([entry]) => {
      // Show only after the button has scrolled above the viewport, not before reaching it.
      const above = entry.boundingClientRect.top < 0;
      this.#setVisible(!entry.isIntersecting && above);
    });
    this.#observer.observe(target);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }

  #setVisible(visible) {
    this.toggleAttribute('data-visible', visible);
    this.toggleAttribute('inert', !visible);
    this.setAttribute('aria-hidden', String(!visible));
  }
}

if (!customElements.get('s-sticky-atc')) customElements.define('s-sticky-atc', SStickyAtc);
